var _defs, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHousingAssetsWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Grupo_11832",
    width: 35.994,
    height: 35.999,
    viewBox: "0 0 35.994 35.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}.cls-2{fill:#09c}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11063",
    transform: "translate(8.345 25.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11058",
    transform: "translate(9.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25667",
    d: "M444.822 131.854a.834.834 0 0 1 .6-.245h6.161a.835.835 0 0 1 .845.822v2.409a1.53 1.53 0 0 0-1.02 1.434v.222h-6.829v-4.028a.848.848 0 0 1 .245-.611z",
    className: "cls-1",
    transform: "translate(-444.576 -131.609)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11059",
    transform: "translate(1.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25668",
    d: "M437.073 131.609h6.2a.834.834 0 0 1 .844.822v4.062h-6.761v-.218a1.534 1.534 0 0 0-1.127-1.467v-2.375a.835.835 0 0 1 .845-.822z",
    className: "cls-1",
    transform: "translate(-436.228 -131.609)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11060",
    transform: "translate(0 3.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25669",
    d: "M434.75 141.623v-5.363a1.059 1.059 0 0 1 2.116 0v.417a.223.223 0 0 0 0 .1v4.85z",
    className: "cls-1",
    transform: "translate(-434.75 -135.227)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11061",
    transform: "translate(2.61 5.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25670",
    d: "M437.35 139.671v-2.707h14.083v2.707z",
    className: "cls-1",
    transform: "translate(-437.35 -136.964)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11062",
    transform: "translate(17.189 3.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25671",
    d: "M453.986 141.623h-2.116v-5.363a1.058 1.058 0 0 1 2.115 0z",
    className: "cls-1",
    transform: "translate(-451.87 -135.227)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25672",
    d: "M431.034 142.687a1.23 1.23 0 0 1-1.212-1.172v-18.781a.834.834 0 0 1 .043-.324v-1.692l-1.435 1.106a1.142 1.142 0 0 1-.8.257 1.161 1.161 0 0 1-.894-.393 1.2 1.2 0 0 1-.291-.918 1.152 1.152 0 0 1 .436-.777l2.982-2.312v-5.711a1.266 1.266 0 1 1 2.532 0v3.784l11.377-8.793a1.924 1.924 0 0 1 1.5-.2 3.98 3.98 0 0 1 1.1.735c.6.469 1.188.93 1.781 1.39l5.585 4.384c1.9 1.5 3.765 2.957 5.668 4.417l2.633 2.042a1.171 1.171 0 0 1 .1 1.645 1.355 1.355 0 0 1-1.721.162l-.525-.4v20.357a1.229 1.229 0 0 1-1.29 1.194h-27.52zm-.166-24.01v3.943l-.05.1.007 18.768a.223.223 0 0 0 .234.191h27.573c.163 0 .255-.088.262-.212v-22.359l2.118 1.611a.343.343 0 0 0 .413-.045.6.6 0 0 0 0-.083.168.168 0 0 0-.057-.114l-2.577-2c-1.9-1.461-3.767-2.923-5.674-4.423l-5.583-4.381c-.593-.46-1.189-.923-1.821-1.424a3.155 3.155 0 0 0-.8-.557.945.945 0 0 0-.6.105l-12.927 10v-5.827c0-.289-.524-.289-.524 0v6.2l-3.368 2.611a.181.181 0 0 0-.023.224.208.208 0 0 0 .164.069.251.251 0 0 0 .163-.038z",
    className: "cls-1",
    transform: "translate(-426.439 -106.688)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11065",
    transform: "translate(10.107 10.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4386",
    d: "M0 0H15.78V11.326H0z",
    className: "cls-1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Trazado_22827",
    transform: "translate(13.077 14.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25673",
    d: "M443.4 120.7h-3.264a.691.691 0 0 0 0 1.382h.96v3.84a.692.692 0 0 0 1.383 0v-3.84h.96a.688.688 0 0 0 .692-.685v-.006a.749.749 0 0 0-.731-.691z",
    className: "cls-2",
    transform: "translate(-439.464 -120.702)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Trazado_22828",
    transform: "translate(18.316 14.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25674",
    d: "M448.828 120.741a.673.673 0 0 0-.848.424l-1 2.881-1-2.881a.668.668 0 1 0-1.267.425l1.535 4.5a.67.67 0 0 0 .654.461h.154a.746.746 0 0 0 .653-.461l1.536-4.5a.672.672 0 0 0-.417-.849z",
    className: "cls-2",
    transform: "translate(-444.681 -120.707)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousingAssetsWhite);
export default __webpack_public_path__ + "static/media/housing-assets-white.b03e062f84b555a577c6bae4a4f464a1.svg";
export { ForwardRef as ReactComponent };